import { useEffect, useState } from "react";
import { msalInstance } from "./authConfig"; // tu archivo MSAL
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";

import './App.css';

import Inicio from './components/Inicio';
import Provincia from './components/Provincia';
import JuanaManso from './components/JuanaManso';
import AprenderConectado from './components/AprenderConectado';
import Nacion from './components/Nacion';
import Descargas from './components/Descargas';
import MatenimientoNacion from './components/MatenimientoNacion';


function App() {

  const [userEmail, setUserEmail] = useState(null);

  useEffect(() => {
    const cuentas = msalInstance.getAllAccounts();

    if (cuentas.length > 0) {
      // Tomamos la primera cuenta activa
      const cuenta = cuentas[0];
      setUserEmail(cuenta.username);
    }
  }, []);


  return (
    <div>
      <div className="App">
        <BrowserRouter>
          <Routes>
            {/* Home: abrí en JuanaManso por defecto (index 2) */}
            <Route path="/" element={<Inicio initialPage={0} />} />

            {/* Alias legibles sin /desbloqueos */}
            <Route path="/inicio" element={<Inicio />} />
            <Route path="/provincia" element={<Inicio initialPage={1} />} />
            <Route path="/juanamanso" element={<Inicio initialPage={2} />} />
            <Route path="/aprender" element={<Inicio initialPage={3} />} />
            <Route path="/nacion" element={<Inicio initialPage={4} userEmail={userEmail} />} />

            <Route path="/descargas" element={<Inicio initialPage={5} />} />

            {/* Compatibilidad hacia atrás (si alguien entra con /desbloqueos o /desbloqueos/:slug) */}
            <Route path="/desbloqueos" element={<Navigate to="/juanamanso" replace />} />
            <Route path="/desbloqueos/:slug" element={<Inicio />} />

            <Route path="*" element={<h1>No existe la página</h1>} />
          </Routes>
        </BrowserRouter>
      </div>
  </div>

  );
}

export default App;